<div class="card card-position pb-5">
  <div class="d-flex justify-content-center align-items-center">
    <div class="col p-0">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
